// Browser storage for this admin app. Keys are namespaced so the admin app and the
// Between business app (different ports, same "localhost" in dev) never read or clear
// each other's session.
const PREFIX = 'between.admin.';

const ACCESS_TOKEN = `${PREFIX}accessToken`;
const REFRESH_TOKEN = `${PREFIX}refreshToken`;
const USERNAME = `${PREFIX}username`;

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage unavailable (private mode / quota): the session just won't persist.
  }
};

const erase = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const authStorage = {
  getAccessToken: (): string | null => read(ACCESS_TOKEN),
  getRefreshToken: (): string | null => read(REFRESH_TOKEN),
  getUsername: (): string | null => read(USERNAME),
  setAccessToken: (access: string): void => write(ACCESS_TOKEN, access),
  setTokens: (access: string, refresh: string): void => {
    write(ACCESS_TOKEN, access);
    write(REFRESH_TOKEN, refresh);
  },
  setUsername: (username: string): void => write(USERNAME, username),
  clear: (): void => {
    erase(ACCESS_TOKEN);
    erase(REFRESH_TOKEN);
    erase(USERNAME);
  },
};

/** Namespaced access for other session-like keys (e.g. Instagram connection state). */
export const scopedStorage = {
  get: (key: string): string | null => read(PREFIX + key),
  set: (key: string, value: string): void => write(PREFIX + key, value),
  remove: (key: string): void => erase(PREFIX + key),
};
